import { atom } from "jotai";

/**
 * Atom to control customer success search modal visibility
 */
export const showSearchAtom = atom<boolean>(false);
showSearchAtom.debugLabel = "Search Modal Visibility";
